import type { FaireProductEntity } from "../../entity_types/product";

export const p_kve2xq463g: FaireProductEntity = {
  token: "p_kve2xq463g",
  type: "product",
  name: "Lymphatic Support Tincture, 2oz",
  brandToken: "b_zqh3u776ct",
  brandName: "Evergreen Apothecary",
  imageUrl:
    "https://cdn.faire.com/fastly/aa7986c14d5d43bc5c166bd71110a8f8268ae26f2d37eca609dcb2a808f0dd99.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8642f0a1514df824ebdeafc69a1eb79605c7847fafb67da5b28b483cedef2483.jpeg",
    "https://cdn.faire.com/fastly/5b6023158c5eaa2ef8d3fc13100a15015c7b563a02b0d20f73a7ff27a3dc4b1f.jpeg",
    "https://cdn.faire.com/fastly/de17a8427c6fc481e25cae636078ab60a88dce1c59423951c27faf3b979e227b.jpeg",
    "https://cdn.faire.com/fastly/ed482a54b33c9338dc5a2990e5fa995902eeda79e52b54fdae58b0b77a50dd32.jpeg",
  ],
  priceDollars: 13,
  description:
    "The lymphatic system plays a critical role in immune function, detoxification, and fluid balance. It helps to clear toxins, cellular waste, and pathogens from the body. The herbs included in this tincture, help stimulate lymph flow and promote detoxification. \n-Since lymph nodes filter pathogens and support white blood cell activity, supporting lymphatic flow can enhance the body's ability to fight infections, especially during cold and flu season. \n-Reduce swelling and fluid retention: A backed-up lymph can cause edema (swelling) and a feeling of heaviness. Lymphatic herbs help move stagnant lymph and excess fluids, often relieving bloating and tissue swelling. \n-Conditions like acne, eczema, or dull skin can be linked to poor lymph drainage. \n-When the lymphatic system is functioning well, toxins are cleared more efficiently, which can lead to improved energy, reduced brain fog, and better overall vitality. \nPairs well with vibration plates.\n\nOut of stock? Feel free to message us!\nLooking for white label? Message us and we are happy to work with you.",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:03.468Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
